import { SliderField } from 'components/Design/SliderField/SliderField'
import { ColorPicker } from '../ColorPicker/ColorPicker'
import { SolidColor } from '../VisualEditor/Types'
import Styles from './FillColor.module.scss'

type Props = {
  value: SolidColor
  onChange: (color: SolidColor) => any
  allowTransparency?: boolean
  margin?: string
  withHexInput?: boolean
}

export const SolidFill = ({
  value,
  onChange,
  allowTransparency = true,
  margin = undefined,
  withHexInput = true,
}: Props) => {
  return (
    <div className={Styles.solidFillContainer}>
      <ColorPicker
        color={value.color}
        withHexInput={withHexInput}
        onChange={(newColor) => onChange({ ...value, color: newColor })}
        margin={margin}
      />
      {allowTransparency && (
        <SliderField
          minValue={0}
          maxValue={100}
          label="Opacity"
          value={value.opacity * 100}
          onChange={(newOpacity) => onChange({ ...value, opacity: newOpacity / 100 })}
        />
      )}
    </div>
  )
}
